import React from 'react';

const UserManagement = () => {
  return (
    <div className="workflow-section">
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-3">User Management</h1>
        <p className="text-xl text-gray-300 leading-relaxed">
          Learn how to manage users and authentication in Drawbridge API.
        </p>
      </div>
      {/* Add workflow content here */}
    </div>
  );
};

export default UserManagement;
